export const ROUTES = [
  { g: "Daily loop", id: "today", label: "Today" },
  { g: "Daily loop", id: "journal", label: "Journal" },
  { g: "Daily loop", id: "behaviour", label: "Behaviour" },
  { g: "Daily loop", id: "coach", label: "Coach" },
  { g: "Record", id: "accounts", label: "Accounts & sync" },
  { g: "Record", id: "ledger", label: "Trade ledger" },
  { g: "Record", id: "analytics", label: "Analytics" },
  { g: "Record", id: "execution", label: "Execution quality" },
  { g: "Record", id: "replay", label: "Trade replay" },
  { g: "Risk", id: "risk", label: "Risk centre" },
  { g: "Risk", id: "calc", label: "Calculators" },
  { g: "Risk", id: "portfolio", label: "Portfolio risk" },
  { g: "Risk", id: "propfirm", label: "Prop-firm hub" },
  { g: "Evidence", id: "strategies", label: "Strategies" },
  { g: "Evidence", id: "research", label: "Backtests", staff: true },
  { g: "Evidence", id: "charts", label: "Charts & news", free: true },
  { g: "Develop", id: "education", label: "Education" },
  { g: "Develop", id: "progression", label: "Progression" },
  { g: "Develop", id: "mentor", label: "Mentoring", staff: true },
  { g: "Public", id: "profile", label: "Public profile" },
  { g: "Public", id: "market", label: "Marketplace", flag: "FEATURE_MARKETPLACE" },
  { g: "Public", id: "referrals", label: "Referrals" },
  { g: "Platform", id: "admin", label: "Admin console", admin: true },
  { g: "Platform", id: "billing", label: "Plan & usage" },
  { g: "Platform", id: "help", label: "Help & support" },
  { g: "Platform", id: "security", label: "Security" },
];
